import * as React from "react";
import { connect } from "react-redux";
import {
  Container,
  Dropdown,
  Form,
  Button,
  Modal,
  ButtonGroup,
  ToggleButtonGroup,
  ToggleButton,
  Spinner,
  Accordion,
  Card,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { PartTemplateService } from "../../Common/Services/PartTemplateService";
import paginationFactory from "react-bootstrap-table2-paginator";

import { CustomerService } from "../../Common/Services/CustomerService";
import { CustomerSearch } from "../../Common/Components/CustomerSearch";
import { SingleSearchDropdownList } from "../../Common/Components/SingleSearchDropdownList";
import _ from "lodash";
import { ConfirmationModal } from "../../Common/Components/ConfirmationModal";
import createDOMPurify from "dompurify";
import { Utils } from "../../Common/Utilis";
import moment from "moment";
import { ProductService } from "../../Common/Services/ProductService";
import DatePicker from "react-datepicker";
class ProductSlideout extends React.Component<any, any> {
  private parentScroll: any;
  private singleSerch: any;
  private customerSearch: any;

  private templateColumns = [

    {
      dataField: 'srno',
      text: 'No.',

    },
    {
      dataField: 'type',
      text: 'Type',
      headerStyle: { width: '150px' },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txttype" + rowIndex + "txt";
        let disable = false;
        return (
          <div>
            <Form.Control tabIndex={this.state.tabEnable}
              id={id}
              type="text" placeholder="Enter Type" value={row.type}
              onChange={(e) => this.updateState(e, rowIndex, "type", id)}
              autoComplete='off'
              disabled={disable}
              title=""
              maxLength={500}
            />
          </div>

        );



      },
    },
    {
      dataField: 'processName',
      text: 'Process',
      headerStyle: { width: '200px' },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtprocess" + rowIndex + "txt";
        let disable = false;
        return (
          <div>
            {/* <Form.Control tabIndex={this.state.tabEnable}
                    id={id}
                    type="text" placeholder="Enter Process" value={row.process}
                   // onChange={(e) => this.updateState(e, rowIndex, "partNo", id)}
                    autoComplete='off'
                    disabled={disable}
                    title=""
                    maxLength={500}
                /> */}


            <SingleSearchDropdownList
              tabIndex={this.state.tabEnable}
              itemList={row.processList}
              handleSelectedItem={this.handleSelectedItem.bind(row, 1 + '_' + rowIndex)}
              defaultItem={row.processName}
              defaultText={"Search Process"}
              defaultName={row.processName}
              controlID="1"
              id={"ddlprocess-" + rowIndex + "ddl"}
            //onTAB={this.onTAB.bind(this, "ddlprocess-" + rowIndex + "ddl", rowIndex)}
            // disabled={disable}
            />
          </div>
        );



      },

    },
    {
      dataField: 'tDescription',
      text: 'Description',
      headerStyle: { width: '400px' },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtdescription" + rowIndex + "txt";
        let disable = false;
        return (
          <div>
            <Form.Control tabIndex={this.state.tabEnable}
              id={id}
              type="text" placeholder="Enter Description" value={row.tDescription}
              onChange={(e) => this.updateState(e, rowIndex, "description", id)}
              autoComplete='off'
              disabled={disable}
              title=""
              maxLength={500}
            />
          </div>

        );



      },

    },
    {
      dataField: 'estimatehour',
      text: 'Estimate Hours',
      headerStyle: { width: '100px' },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtestimate" + rowIndex + "txt";
        let disable = false;
        return (
          <div>
            <Form.Control tabIndex={this.state.tabEnable}
              id={id}
              type="text" placeholder="Enter Estimate Hours" value={row.estimatehour}
              onChange={(e) => this.updateState(e, rowIndex, "estimate", id)}
              autoComplete='off'
              disabled={disable}
              title=""
              maxLength={500}
            />
          </div>

        );



      },

    },

    {
      dataField: 'Attachment',
      text: '',
      //headerFormatter: this.iconFormatter,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let confirmModalContent = [
          {
            title: "Delete Row",
            desc: "Are you sure you want to delete?",
            cancleAction: "Cancel",
            ActionTrue: "Delete",
          },
        ];
        if (this.state.templateData.length === 1) {
          return (
            <div></div>
          );
        }
         

        else {
          return (
            <Dropdown className="more-action confirmation-modal"  tabIndex={this.state.tabDisable}>
              <Dropdown.Toggle className="btn-outline-primary btn btn-primary more fa-trash" id="dropdown-more-delete" tabIndex={this.state.tabDisable}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 5.83329C4.53917 5.83329 4.16667 5.83329 4.16667 5.83329V16.6666C4.16667 17.5866 4.91333 18.3333 5.83333 18.3333H14.1667C15.0867 18.3333 15.8333 17.5866 15.8333 16.6666V5.83329C15.8333 5.83329 15.4608 5.83329 15 5.83329H5ZM8.33333 15.8333H6.66667V8.33329H8.33333V15.8333ZM13.3333 15.8333H11.6667V8.33329H13.3333V15.8333ZM13.8483 3.33329L12.5 1.66663H7.5L6.15167 3.33329H2.5V4.99996H6.66667H13.3333H17.5V3.33329H13.8483Z" />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <ConfirmationModal
                  confirmModalContent={confirmModalContent}
                  ishandleDeletePosition={this.ishandleDeleteRow.bind(
                    this,
                    row
                  )}
                />
              </Dropdown.Menu>
            </Dropdown>
          );
        }
      },
    }
  ];

  handleSelectedItem = (control: any, id: any) => {
    
    let isStateChanged = true;
    let formData = { ...this.state.formData };
    let controlID = Number(control.split('_')[0]);
    let rowIndex = Number(control.split('_')[1]);
    let templateData = Object.assign([], JSON.parse(JSON.stringify(this.state.templateData)));
    if (controlID === 1) {
      let filterRow = this.state.processdataList.filter(x => x.id === id);

      //templateData[rowIndex].processList = this.state.processdataList.filter(x => x.id === filterRow[0].id);

      templateData[rowIndex].processName = filterRow[0].processName;
      templateData[rowIndex].processid = filterRow[0].id;
      templateData[rowIndex].tDescription = filterRow[0].pDescription;

      this.setState({ templateData: [] }, () => {
        this.setState({ templateData, isStateChanged }, () => {
          let txtID = 'ddlprocess-' + (rowIndex) + "ddl";
          $("#tbltemplate").find("button[id^='" + txtID + "']").focus();
        });
      });

    }

  };
  updateState = (e: any, index: any, type: any, txtID) => {
    if (this != undefined) {
      let isStateChanged = true;
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;
      let templateData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.templateData))
      );


      if (type === "type") {

        templateData[index].type = e.target.value;

        this.setState({ templateData, isStateChanged }, () => {
          $("#tbltemplate")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      if (type === "description") {

        templateData[index].tDescription = e.target.value;

        this.setState({ templateData, isStateChanged }, () => {
          $("#tbltemplate")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

      if (type === "estimate") {
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
        templateData[index].estimatehour = e.target.value;

        this.setState({ templateData, isStateChanged }, () => {
          $("#tbltemplate")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }



    }
  };


   onAmountFocus = (e, index, txtID, type: any) => {
  
      //let newval = Utils.removecurrencyFormat(e.target.value);
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;
    
  
      if (type === "qty1") {
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        this.state.qoSetup[index].qty1 = e.target.value;
      }
      if (type === "qty2") {
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        this.state.qoSetup[index].qty2 = e.target.value;
      }
      if (type === "qty3") {
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        this.state.qoSetup[index].qty3 = e.target.value;
      }
      if (type === "qty4") {
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        this.state.qoSetup[index].qty4 = e.target.value;
      }
      if (type === "qty5") {
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        this.state.qoSetup[index].qty5 = e.target.value;
      }
 
  
  
      // this.setState({ orderData }, () => {
      //     $("#tblOrder").find("input[id^='" + txtID + "']").focus();
      // });
    };


     amountBlur = (e, rowIndex, type: any) => {
    
    
        if (e.target.value.includes(".")) {
          const timeArray = e.target.value?.split(".");
          if (timeArray[1].length <= 0) {
          
            if (type === "qty1") {
              this.state.qoSetup[rowIndex].qty1 = timeArray[0];
              // Utils.currencyFormat(
              //   timeArray[0]
              // );
            }
            if (type === "price") {
              this.state.quotationBreakupPrice[rowIndex].price = Utils.currencyFormat(
                timeArray[0]
              );
            }
            if (type === "qty2") {
              this.state.qoSetup[rowIndex].qty2 = timeArray[0];
              // Utils.currencyFormat(
              //   timeArray[0]
              // );
            }
            if (type === "qty3") {
              this.state.qoSetup[rowIndex].qty3 = timeArray[0];
              //  Utils.currencyFormat(
              //   timeArray[0]
              // );
            }
            if (type === "qty4") {
              this.state.qoSetup[rowIndex].qty4 = timeArray[0];
              // Utils.currencyFormat(
              //   timeArray[0]
              // );
            }
            if (type === "qty5") {
              this.state.qoSetup[rowIndex].qty5 = timeArray[0];
              // Utils.currencyFormat(
              //   timeArray[0]
              // );
            }
          } else {
            if (type === "qty1") {
              this.state.qoSetup[rowIndex].qty1 = e.target.value;
            }
            if (type === "qty2") {
              this.state.qoSetup[rowIndex].qty2 = e.target.value;
            }
            if (type === "qty3") {
              this.state.qoSetup[rowIndex].qty3 = e.target.value;
            }
            if (type === "qty4") {
              this.state.qoSetup[rowIndex].qty4 = e.target.value;
            }
            if (type === "qty5") {
              this.state.qoSetup[rowIndex].qty5 = e.target.value;
            }
    
          }
    
          this.setState({ qoSetup: this.state.qoSetup});
        } else {
          if (type === "qty1") {
            this.state.qoSetup[rowIndex].qty1 =
              e.target.value === ""
                ? "0"
                : !isNaN(e.target.value)
                  ? e.target.value
                  : e.target.value;
    
          }
          if (type === "qty2") {
            this.state.qoSetup[rowIndex].qty2 =
              e.target.value === ""
                ? "0"
                : !isNaN(e.target.value)
                  ? e.target.value
                  : e.target.value;
    
          }
          if (type === "qty3") {
            this.state.qoSetup[rowIndex].qty3 =
              e.target.value === ""
                ? "0"
                : !isNaN(e.target.value)
                  ? e.target.value
                  : e.target.value;
    
          }
          if (type === "qty4") {
            this.state.qoSetup[rowIndex].qty4 =
              e.target.value === ""
                ? "0"
                : !isNaN(e.target.value)
                  ? e.target.value
                  : e.target.value;
    
          }
          if (type === "qty5") {
            this.state.qoSetup[rowIndex].qty5 =
              e.target.value === ""
                ? "0"
                : !isNaN(e.target.value)
                  ? e.target.value
                  : e.target.value;
    
          }
          
          this.setState({ qoSetup: this.state.qoSetup });
        }
      };

      handleTabKeyDown = (e, rowIndex: number, field: string) => {
    // if (e.key === 'Tab') {
    //   // e.preventDefault(); 
    //  console.log("ooo",rowIndex,field);
    //   // Get the next field
    //   const nextField = this.getNextFieldId(rowIndex, field);
    //    console.log("nextField",nextField);

    //     let txtID = 'txt'+nextField.toString()+'txt';

    //     $("#tblpricebreakup")
    //       .find("input[id^='" + txtID + "']")
    //       .focus();
    // // setTimeout(() => {
    //   // const nextElement = document.getElementById('txt'+nextField.toString()+'txt');
    //   // if (nextElement) {
    //   //   (nextElement as HTMLElement).focus();
    //   // } else {
    //   //   console.warn(`Field with ID '${nextField}' not found.`);
    //   // }
    // // }, 5);
    // }
  };

 calculateTotals = () => {
    const { qoSetup } = this.state;
if(qoSetup.length>0)
{

// debugger;

    const totals = {
      qty1: 0,
      qty2: 0,
      qty3: 0,
      qty4: 0,
      qty5: 0,
      partId: qoSetup[0]?.partId || 0
    };
    //console.log("beforetotals", qoSetup);

    // Accumulate totals for each quantity field
    qoSetup.filter(x => x.itemName != "Quantity").forEach(item => {

      totals.qty1 += parseFloat(Utils.removecurrencyFormat(item.qty1)) || 0;
      totals.qty2 += parseFloat(Utils.removecurrencyFormat(item.qty2)) || 0;
      totals.qty3 += parseFloat(Utils.removecurrencyFormat(item.qty3)) || 0;
      totals.qty4 += parseFloat(Utils.removecurrencyFormat(item.qty4)) || 0;
      totals.qty5 += parseFloat(Utils.removecurrencyFormat(item.qty5)) || 0;
    });





    const totalBreakTotal1 = this.state.qoSetup.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid).reduce((sum, obj) => {

      
      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.qty1));
      return sum + currentvalue;
    }, 0);


    const totalBreakTotal2 = this.state.qoSetup.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid).reduce((sum, obj) => {

      
      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.qty2));
      return sum + currentvalue;
    }, 0);


    const totalBreakTotal3 = this.state.qoSetup.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid).reduce((sum, obj) => {

      
      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.qty3));
      return sum + currentvalue;
    }, 0);

    const totalBreakTotal4 = this.state.qoSetup.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid).reduce((sum, obj) => {

      
      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.qty4));
      return sum + currentvalue;
    }, 0);

    const totalBreakTotal5 = this.state.qoSetup.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid).reduce((sum, obj) => {

      
      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.qty5));
      return sum + currentvalue;
    }, 0);

    this.setState({ totals });
  }
  };


   updateState1 = (e: any, index: any, type: any, txtID) => {
      if (this != undefined && e != null) {
        
        let isStateChanged = true;
        let start = e.target?.selectionStart;
        let end = e.target?.selectionEnd;
    
        let qoSetup = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.qoSetup))
        );
        // let quotationBreakupPrice = Object.assign(
        //   [],
        //   JSON.parse(JSON.stringify(this.state.quotationBreakupPrice == undefined ? null : this.state.quotationBreakupPrice))
        // );
  
        // let priceBreakupSetup = Object.assign(
        //   [],
        //   JSON.parse(JSON.stringify(this.state.priceBreakupSetup == undefined ? null : this.state.priceBreakupSetup))
        // );
  
  
  
        if (type === "qty1") {
          // let newVal =Utils.removeInvaildCharFromAmount(e.target.value);
          // e.target.value = newVal;
          ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
          qoSetup[index].qty1 = e.target.value;
  
          this.setState({ qoSetup ,isStateChanged}, () => {
            this.calculateTotals();
            $("#tblpricebreakup")
              .find("input[id^='" + txtID + "']")
              .focus();
            let txtdesc = $("#tblpricebreakup").find(
              "input[id^='" + txtID + "']"
            )[0] as any;
            if (txtdesc !== null && txtdesc !== undefined) {
              txtdesc.selectionStart = start;
              txtdesc.selectionEnd = end;
            }
          });
        }
  
  
        if (type === "qty2") {
          // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
          // e.target.value = newVal;
          ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
          qoSetup[index].qty2 = e.target.value;
  
          this.setState({ qoSetup ,isStateChanged}, () => {
            this.calculateTotals();
            $("#tblpricebreakup")
              .find("input[id^='" + txtID + "']")
              .focus();
            let txtdesc = $("#tblpricebreakup").find(
              "input[id^='" + txtID + "']"
            )[0] as any;
            if (txtdesc !== null && txtdesc !== undefined) {
              txtdesc.selectionStart = start;
              txtdesc.selectionEnd = end;
            }
          });
        }
  
        if (type === "qty3") {
          // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
          // e.target.value = newVal;
          ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
          qoSetup[index].qty3 = e.target.value;
  
          this.setState({ qoSetup ,isStateChanged}, () => {
            this.calculateTotals();
            $("#tblpricebreakup")
              .find("input[id^='" + txtID + "']")
              .focus();
            let txtdesc = $("#tblpricebreakup").find(
              "input[id^='" + txtID + "']"
            )[0] as any;
            if (txtdesc !== null && txtdesc !== undefined) {
              txtdesc.selectionStart = start;
              txtdesc.selectionEnd = end;
            }
          });
        }
  
        if (type === "qty4") {
          // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
          // e.target.value = newVal;
          ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
          qoSetup[index].qty4 = e.target.value;
  
          this.setState({ qoSetup,isStateChanged }, () => {
            this.calculateTotals();
            $("#tblpricebreakup")
              .find("input[id^='" + txtID + "']")
              .focus();
            let txtdesc = $("#tblpricebreakup").find(
              "input[id^='" + txtID + "']"
            )[0] as any;
            if (txtdesc !== null && txtdesc !== undefined) {
              txtdesc.selectionStart = start;
              txtdesc.selectionEnd = end;
            }
          });
        }
  
        if (type === "qty5") {
          // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
          // e.target.value = newVal;
          ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
          qoSetup[index].qty5 = e.target.value;
  
          this.setState({ qoSetup ,isStateChanged}, () => {
            this.calculateTotals();
            $("#tblpricebreakup")
              .find("input[id^='" + txtID + "']")
              .focus();
            let txtdesc = $("#tblpricebreakup").find(
              "input[id^='" + txtID + "']"
            )[0] as any;
            if (txtdesc !== null && txtdesc !== undefined) {
              txtdesc.selectionStart = start;
              txtdesc.selectionEnd = end;
            }
          });
        }
        if (type === "itemName") {
          // let newVal = e.target.value.replace(/[^0-9\s]/g, '');
          // e.target.value = newVal;
          ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
          qoSetup[index].itemName = e.target.value;
  
          this.setState({ qoSetup, isStateChanged }, () => {
            $("#tblpricebreakup")
              .find("input[id^='" + txtID + "']")
              .focus();
            let txtdesc = $("#tblpricebreakup").find(
              "input[id^='" + txtID + "']"
            )[0] as any;
            if (txtdesc !== null && txtdesc !== undefined) {
              txtdesc.selectionStart = start;
              txtdesc.selectionEnd = end;
            }
          });
        }
  
  
      }
    };

  constructor(props: any) {
    super(props);
    this.handleNewRow = this.handleNewRow.bind(this);
    this.GetProcesslist = this.GetProcesslist.bind(this);
     this.GetTemplateData=this.GetTemplateData.bind(this);     
    this.customerSearch = React.createRef();
    this.state = {
      templateid: this.props.templateid,
      qoSetup: [],
      totals: {
        qty1: 0,
        qty2: 0,
        qty3: 0,
        qty4: 0,
        qty5: 0,
        partId: 0
      },
      htmlItem: [],
      htmlErrorItem: [],
      htmlWarningItem: [],
      searcResult: [],
      customerList: [],
      templatename: "",
      processdataList: [],
      templatelistitem: [],
      templateColumns: this.templateColumns,
      formData: {
        templateid: 0,
        templatename: "",
        TemplateDetails: [],
        noofday:0,
        



      },
      templateData: [
        {
          processList: [],
          processName: "", processid: 0, srno: 1, type: 'Work', tDescription: '', estimatehour: '',
        }

      ],

      newRow: [
        {
          processList: [],
          processName: "", processid: 0, srno: 1, type: 'Work', tDescription: '', estimatehour: '',
        }

      ],
    };


  }
  componentDidMount() {
    let requestlist = { ...this.state.requestlist };
   // let requestlist = { ...this.state.requestlist };
    if (this.customerSearch.current !== null) {
      this.customerSearch.current.GetCustomerTranlist(requestlist);
    }
    //this.GetProcesslist(requestlist);
    this.GetCustomerlist(requestlist);
   
  }


  

  

  GetProductById = () => {
    let request: any = {};
    request.productid = this.props.productid;
    ProductService.GetProductById(request)
    .then(async (result: any | null) => {
      if (result !== null) {
        let custommerSelected: any = [];
        let formData = { ...this.state.formData };        
        let priceOptions: any = result.priceBreakupDto;
        formData.Id = result.id;
        formData.partname = result.partname;
        formData.firstline=result.partname.split('\n')[0];
        formData.partno = result.partno;
        formData.tenantid = result.tenantid;
        formData.UnitPrice = result.unitPrice;
      
        formData.Noofday = result.noofday;
        formData.pdescription = result.pdescription;
        formData.customerid = result.customerid;
        if(this.state.customerList.length > 0)
        {
          
         let customer = this.state.customerList.filter((x)=>x.customer_id == result.customerid);

        custommerSelected.company_name = customer != null && customer.length> 0 ? customer[0].company_name :'';
        //custommerSelected.address = mainArray.address;
        custommerSelected.customer_id = result.customerid;
        formData.customercode=customer[0].customercode;
        //custommerSelected.customercode = mainArray.customercode;
        this.customerSearch?.current.handleSelectFromParent(
          custommerSelected
        );

        }

        this.setState({
          formData: formData,
          qoSetup:priceOptions
        },
          () => {                   this.calculateTotals();
 });
      }
      resolve();
    })
    .catch((error) => {
      this.setState({ isSpinner: false });
      reject();
    });

    
  };

  saveProduct = () => {
    let formData = { ...this.state.formData };
    this.setState({ isSaveSpinner: true });

    let isFormValid = true;
    let request: any = {};

    
    request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));
    request.PriceBreakupDto = this.state.qoSetup || [];


    if (request.partname === "") {
      toast.error("Please enter part name.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false });
      return false;
    }


    isFormValid = true;


    if (isFormValid) {
      this.setState({ saveRequest: request, ispopupshow: false});

      ProductService.SaveProductMaster(request)
        .then(async (result: any | null) => {
          if (result !== null) {
            
            this.setState({ isSaveSpinner: false });


            toast.success('Part details successfully updated.', {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
          }
          this.closeSlideOut();
          

          resolve();
        })
        .catch((error) => {
          this.setState({ isdefaultColDisabled: false, isSpinner: false,isSaveSpinner:false });
          reject();
        });
    }
  };
  GetTemplateData = () => {
    
    let saveRequest: any = {};
    saveRequest.id = this.state.templateid;
    saveRequest.tenantid = 0;

    let templateData: any = [];
   // templateData = Object.assign([], JSON.parse(JSON.stringify(this.state.templateData)));
    PartTemplateService.GetTemplatedata(saveRequest)
      .then(async (result: any | null) => {
        if (result !== null) {


          let formData = { ...this.state.formData };
          

          formData.templatename = result[0].templatename;
         
          let orderArray: any = [];
          orderArray = result[0].templateDetails;
          if (orderArray.length > 0) {
            orderArray.forEach((element, idx) => {

               let filterRow = this.state.processdataList.filter(x => x.id === orderArray[idx].processid);

              
               
              element.processList = this.state.processdataList;


               element.processName = filterRow[0].processName;
              element.processid = orderArray[idx].processid;

              templateData.push(element);
            });
          }
          else {
            templateData = Object.assign(
              [],
              JSON.parse(JSON.stringify(this.state.templateData))
            );
          }
          ;

          this.setState({
            tempateData: templateData,
            formData: formData,
          },
            () => {
              this.setState({ tempateData: [] }, () => {
                this.setState({ templateData: templateData });
          
              });       
  console.log(templateData);
            });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSaveSpinner: false });
        reject();
      });
  };

  ishandleDeleteRow(row: any, mode: any) {
    if (mode) {

      let templateData = Object.assign([], JSON.parse(JSON.stringify(this.state.templateData)));

      this.setState({ templateData: [] }, () => {


        const templateDataNewc = templateData.filter(item => item.templateno !== row.templateno).map((item, index) => {

          item.templateno = index + 1;


          return item;
        });

        this.setState({
          templateData: templateDataNewc,
          isStateChanged: true

        },
          () => {


          });
      });
    }
  }

  closeSlideOut = () => {
    this.props.closeSlideOut(this.state?.shouldReloadMainPage);

  };

  handleNewRow = () => {

    let templateData: any = [];
    let newRow: any = {};
    let isStateChanged = true;

    
    templateData = Object.assign([], JSON.parse(JSON.stringify(this.state.templateData)));
    newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.newRow)));

    let maxValueOfRow = Math.max(...templateData.map(o => o.srno), 0);
    let len = templateData.length;
    let maxRno = maxValueOfRow;
    let maxSrno = len > 0 ? templateData[len - 1].srno : maxValueOfRow;
    newRow[0].srno = Number(maxSrno) + 1;
    if (newRow[0].processList && newRow[0].processList[1]) {
      newRow[0].processList[1].id = Number(maxSrno) + 1;
    }
    let filterRow = this.state.processdataList.filter(x => x.srno === Number(maxSrno) + 1);

    if (filterRow.length != 0) {
      newRow[0].tDescription = filterRow[0].pDescription;

      newRow[0].processName = filterRow[0].processName;
      newRow[0].processid = filterRow[0].id;
    }
    templateData.push(newRow[0]);
    this.setState({ tempateData: [] }, () => {
      this.setState({ templateData: templateData, isStateChanged });

    });




  };

  handleDiscard(postID) {
    this.setState({ isStateChanged: false }, () => {
      this.closeSlideOut();
    });
  }

  GetProcesslist = (requestlist: any) => {




    let templateData: any = [];
    templateData = Object.assign([], JSON.parse(JSON.stringify(this.state.templateData)));
    let newRow = this.state.newRow;
    PartTemplateService.GetProcessList(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {



          templateData.forEach(element => {
            element.processList = result;

          });
          newRow.forEach(element => {
            element.processList = result;

          });
          //  newRow.processList=result;


          this.setState({ templateData: [], processdataList: [] },
            () => {
              this.setState({
                templateData: templateData,
                newRow: newRow,
                processdataList: result,
              }
                ,
                () => {
                  let formData = { ...this.state.formData };

                  this.GetTemplateData();

                  console.log(templateData);
                }

              );
            });
        }
        resolve();
        // console.log(this.state.processList);
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });

  };

   

  HidecloseSlideOut() {
    this.props.closeSlideOut();
    this.setState({ isSaveSpinner: false });
  }

 

  savetemplate = (entryType, isCopy) => {
    let formData = { ...this.state.formData };

    let isFormValid = true;
    let request: any = {};


    let templateData = this.state.templateData;
    this.state.formData.TemplateDetails = templateData;

    request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));



    if (request.templatename === "") {
      toast.error("Please enter template name.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      // this.setState({ isSaveSpinner: false });
      return false;
    }


    isFormValid = true;


    if (isFormValid) {
      this.setState({ saveRequest: request, ispopupshow: false });

      PartTemplateService.SaveTemplateData(request)
        .then(async (result: any | null) => {
          if (result !== null) {
            
            // this.setState({ isSaveSpinner: false });


            toast.success(result.result, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
          }
          if (result.message == "Success") {
            this.HidecloseSlideOut();
          }


          resolve();
        })
        .catch((error) => {
          this.setState({ isdefaultColDisabled: false, isSpinner: false });
          reject();
        });
    }
  };



  handleChange = (event: any, FieldType: string) => {
    let isStateChanged = true;
    let start = 0;
    let end = 0;

    let formData = { ...this.state.formData };

    if (FieldType === "partname") {
      formData.partname =
        event.target.value.trim().length > 0 ? event.target.value : "";
    }
    else if (FieldType === "partno") {
      formData.partno =
        event.target.value.trim().length > 0 ? event.target.value : "";
    }
    else if (FieldType === "pdescription") {
      formData.pdescription =
        event.target.value.trim().length > 0 ? event.target.value : "";
    }
    
    else if (FieldType === "UnitPrice") {
      formData.UnitPrice =
        event.target.value.trim().length > 0 ? event.target.value : 0;
    }
    else if (FieldType === "DeliveryTime") {
      formData.noofday =
        event.target.value.trim().length > 0 ? event.target.value : 0;
    }
    
    this.setState({ formData, isStateChanged, isSpinner: false }, () => {

    });
  };
  updateCustomerList = (result: any) => {
   
    this.setState({ customerList: [] }, () => {
      this.setState({ customerList: result });
    });
  };

  handleCustomerChange = (e: any) => {
    let isStateChanged = true;
    if (e.length > 0) {
      let requestlist = { ...this.state.requestlist };

      let formData = { ...this.state.formData };
      requestlist.vid = e[0].customer_id;
      formData.CustomerID = e[0].customer_id;
      formData.CustomerName = e[0].company_name;
      formData.address = e[0].address;
      formData.customercode = e[0].customercode;
      this.setState({
        CustomerName: e[0].company_name,
        address: e[0].address,
        customercode: e[0].customercode,
        isStateChanged:true
      });
      this.state.formData.CustomerID = e[0].customer_id;
      this.state.formData.CustomerName = e[0].company_name;

    
      
    
    } 
  };

  GetCustomerlist = (requestlist: any) => {
    CustomerService.GetCustomerlist(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ customerList: result, isSpinner: false });
        }
        this.GetProductById();
        resolve();
      })
      .catch((error) => {
        this.setState({ isSaveSpinner: false });
        reject();
      });
  };

   handleNewRowPrice = () => {

    let qoSetup: any = [];
    let newRow: any = {};
    let isStateChanged = true;

    qoSetup = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.qoSetup))
    );

    newRow = {

      id: 0,
      itemName: "",
      partId: this.state.selectedpartid,
      rowId: qoSetup.length + 1,
      detailId: this.state.detatilselectedid,
      priceId: 0,


      qty1: 0,
      qty2: 0,
      qty3: 0,
      qty4: 0,
      qty5: 0,

      tenantId: 0
    };

    qoSetup.push(newRow);

    this.setState({ qoSetup: [] }, () => {
      this.setState({ qoSetup: qoSetup, isStateChanged }, () => {



        let len = this.state.qoSetup.length;
        let txtID = "txtitemname" + (len - 1);
        setTimeout(() => {

          $("input[id^='" + txtID + "']").focus();

        }, 50);

      });
    });

  };


  render() {
     const { permissions } = this.props; 
    const hasEditPermission = permissions && permissions['Part Master'] ? permissions['Part Master'].includes('Edit Part') : false;
    const {

    } = this.state;
 
     const columns1 = [
          {
            dataField: 'label',
            text: '',
            headerStyle: { width: '42%' },
            headerClasses: 'd-none',
            classes: 'text-start pe-4',
            formatter: (cell, row, rowIndex) => {
              let id = `label${rowIndex}`;
              return (
                <div>
                  <Form.Control
                    tabIndex={this.state.tabEnable}
                    type="text"
                    value="Total Price ($)"
                    disabled={true}
                    className="form-control form-control-sm no-border"
                    style={{ fontWeight: "bold" }}
                  />
                </div>
              );
            },
          },
          {
            dataField: 'qty1',
            text: '',
            headerStyle: { width: '15%' },
            headerClasses: 'd-none',
            classes: 'text-end pe-4',
            formatter: (cell, row, rowIndex) => {
              let id = `totalqty1${rowIndex}`;
            //  console.log("yooo", row.qty1);
    
              return (
                <div>
                  <Form.Control
                    tabIndex={this.state.tabEnable}
                    id={id}
                    type="text"
                    placeholder="Enter Total"
                    value={Utils.currencyFormat(row.qty1)}
                    autoComplete="off"
                    pattern="[+-]?\d+(?:[.,]\d+)?"
                    maxLength={20}
                    className="form-control form-control-sm"
                    style={{ textAlign: 'right', fontWeight: "bold" }}
                  />
                </div>
              );
            },
          },
          {
            dataField: 'qty2',
            text: '',
            headerStyle: { width: '15%' },
            headerClasses: 'd-none',
            classes: 'text-end pe-4',
            formatter: (cell, row, rowIndex) => {
              let id = `totalqty2${rowIndex}`;
              return (
                <div>
                  <Form.Control
                    tabIndex={this.state.tabEnable}
                    id={id}
                    type="text"
                    placeholder="Enter Total"
                    value={Utils.currencyFormat(row.qty2)}
                    autoComplete="off"
                    pattern="[+-]?\d+(?:[.,]\d+)?"
                    maxLength={20}
                    className="form-control form-control-sm"
                    style={{ textAlign: 'right', fontWeight: "bold", backgroundColor: '#ffbaba8a' }}
                  />
                </div>
              );
            },
          },
          {
            dataField: 'qty3',
            text: '',
            headerStyle: { width: '15%' },
            headerClasses: 'd-none',
            classes: 'text-end pe-4',
            formatter: (cell, row, rowIndex) => {
              let id = `totalqty3${rowIndex}`;
              return (
                <div>
                  <Form.Control
                    tabIndex={this.state.tabEnable}
                    id={id}
                    type="text"
                    placeholder="Enter Total"
                    value={Utils.currencyFormat(row.qty3)}
                    autoComplete="off"
                    pattern="[+-]?\d+(?:[.,]\d+)?"
                    maxLength={20}
                    className="form-control form-control-sm"
                    style={{ textAlign: 'right', fontWeight: "bold", backgroundColor: '#ffbaba8a' }}
                  />
                </div>
              );
            },
          },
          {
            dataField: 'qty4',
            text: '',
            headerStyle: { width: '15%' },
            headerClasses: 'd-none',
            classes: 'text-end pe-4',
            formatter: (cell, row, rowIndex) => {
              let id = `totalqty4${rowIndex}`;
              return (
                <div>
                  <Form.Control
                    tabIndex={this.state.tabEnable}
                    id={id}
                    type="text"
                    placeholder="Enter Total"
                    value={Utils.currencyFormat(row.qty4)}
                    autoComplete="off"
                    pattern="[+-]?\d+(?:[.,]\d+)?"
                    maxLength={20}
                    className="form-control form-control-sm"
                    style={{ textAlign: 'right', fontWeight: "bold", backgroundColor: '#ffbaba8a' }}
                  />
                </div>
              );
            },
          },
    
    
          {
            dataField: 'qty5',
            text: '',
            headerStyle: { width: '15%' },
            headerClasses: 'd-none',
            classes: 'text-end pe-4',
            formatter: (cell, row, rowIndex) => {
              let id = `totalqty5${rowIndex}`;
              return (
                <div>
                  <Form.Control
                    tabIndex={this.state.tabEnable}
                    id={id}
                    type="text"
                    placeholder="Enter Total"
                    value={Utils.currencyFormat(row.qty5)}
                    autoComplete="off"
                    pattern="[+-]?\d+(?:[.,]\d+)?"
                    maxLength={20}
                    className="form-control form-control-sm"
                    style={{ textAlign: 'right', fontWeight: "bold", backgroundColor: '#ffbaba8a' }}
                  />
                </div>
              );
            },
          },
        ];

    const columns = [
          // {
          //   dataField: 'partId',
          //   text: 'partid',
          //   headerStyle: { width: '50px' },
          // },
          {
            dataField: 'itemName',
    
            text: '',
            headerStyle: { width: '42%' },
    
            headerClasses: 'd-none',
            classes: 'text-start pe-4',
            formatter: (cell: any, row: any, rowIndex: any) => {
              let id = "txtitemname" + rowIndex;
              let disable = this.state.formData.CustomerID == 0 ? true : false;
              let isBold = row.itemName == "Quantity" ? true :false;
              return (
                <div>
                  <Form.Control
                    tabIndex={this.state.tabEnable}
                    id={id}
                    type="text"
                    placeholder="Enter"
                    value={row.itemName}
                    onChange={(e) => this.updateState1(e, rowIndex, "itemName", id)}
                    //  onBlur={(e: any) => this.amountBlur(e, rowIndex, "qtyOrdered")}
                    autoComplete="off"
                    pattern="[+-]?\d+(?:[.,]\d+)?"
                    maxLength={20}
                    disabled={(row.priceId != 0) || row.itemName == "Quantity" ? true : false}
                    title=""
                    
                    className="form-control form-control-sm"
                    style={{ fontWeight: isBold ? 'bold' : 'normal' }}
                  />
                </div>
              );
            },
          },
          {
            dataField: 'qty1',
    
            text: '',
            headerStyle: { width: '15%' },
            headerClasses: 'd-none',
            classes: 'text-end pe-4',
            formatter: (cell: any, row: any, rowIndex: any) => {
              let id = "txtqty1" + rowIndex + "txt";
              let disable = this.state.formData.CustomerID == 0 ? true : false;
              let isBold = row.itemName == "Quantity" ? true :false;
              return (
                <div>
                  <Form.Control
                    tabIndex={this.state.tabEnable}
                    id={id}
                    type="text"
                    placeholder="Enter Price"
                    value={row.qty1}
                    onChange={(e) => this.updateState1(e, rowIndex, "qty1", id)}
                    onBlur={(e: any) => this.amountBlur(e, rowIndex, "qty1")}
                    onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "qty1")}
                    onKeyDown={(e) => this.handleTabKeyDown(e, rowIndex, "qty1")}
                    autoComplete="off"
                    pattern="[+-]?\d+(?:[.,]\d+)?"
                    maxLength={20}
                    // disabled={  row.itemName=="Quantity" ? true:false }
                    title=""
                    className="form-control form-control-sm"
                    style={{ textAlign: 'right', fontWeight: isBold ? 'bold' : 'normal' }}
    
                  />
                </div>
              );
            },
    
    
          },
          {
            dataField: 'qty2',
    
            text: '',
            headerStyle: { width: '15%' },
            headerClasses: 'd-none',
            classes: 'text-end pe-4',
    
            formatter: (cell: any, row: any, rowIndex: any) => {
              let id = "txtqty2" + rowIndex + "txt";
              let disable = this.state.formData.CustomerID == 0 ? true : false;
              let isBold = row.itemName == "Quantity" ? true :false;
              return (
                <div>
                  <Form.Control
                    tabIndex={this.state.tabEnable}
                    id={id}
                    type="text"
                    placeholder="Enter Price"
                    value={row.qty2 == null ? 0 : row.qty2}
                    onChange={(e) => this.updateState1(e, rowIndex, "qty2", id)}
                    onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "qty2")}
                    onBlur={(e: any) => this.amountBlur(e, rowIndex, "qty2")}
                    onKeyDown={(e) => this.handleTabKeyDown(e, rowIndex, "qty2")}
                    autoComplete="off"
                    pattern="[+-]?\d+(?:[.,]\d+)?"
                    maxLength={20}
                    // disabled={  row.itemName=="Quantity" ? true:false}
                    title=""
                    className="form-control form-control-sm"
                    style={{ textAlign: 'right', fontWeight: isBold ? 'bold' : 'normal', backgroundColor: row.itemName == "Quantity" ? '#e9ecef' : '#ffbaba8a' }}
                  />
                </div>
              );
            },
          },
          {
            dataField: 'qty3',
    
            text: '',
            headerStyle: { width: '15%' },
            headerClasses: 'd-none',
            classes: 'text-end pe-4',
            formatter: (cell: any, row: any, rowIndex: any) => {
              let id = "txtqty3" + rowIndex + "txt";
              let disable = this.state.formData.CustomerID == 0 ? true : false;
              let isBold = row.itemName == "Quantity" ? true :false;
              return (
                <div>
                  <Form.Control
                    tabIndex={this.state.tabEnable}
                    id={id}
                    type="text"
                    placeholder="Enter Price"
                    value={row.qty3 == null ? 0 : row.qty3}
                    onChange={(e) => this.updateState1(e, rowIndex, "qty3", id)}
                    onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "qty3")}
                    onBlur={(e: any) => this.amountBlur(e, rowIndex, "qty3")}
                    onKeyDown={(e) => this.handleTabKeyDown(e, rowIndex, "qty3")}
                    autoComplete="off"
                    pattern="[+-]?\d+(?:[.,]\d+)?"
                    maxLength={20}
                    //  disabled={  row.itemName=="Quantity"  ? true:false}
                    title=""
                    className="form-control form-control-sm"
                    style={{ textAlign: 'right', fontWeight: isBold ? 'bold' : 'normal', backgroundColor: row.itemName == "Quantity" ? '#e9ecef' : '#ffbaba8a' }}
                  />
                </div>
              );
            },
          },
          {
            dataField: 'qty4',
    
            text: '',
            headerStyle: { width: '15%' },
            headerClasses: 'd-none',
            classes: 'text-end pe-4',
    
            formatter: (cell: any, row: any, rowIndex: any) => {
              let id = "txtqty4" + rowIndex + "txt";
              let disable = this.state.formData.CustomerID == 0 ? true : false;
              let isBold = row.itemName == "Quantity" ? true :false;
              return (
                <div>
                  <Form.Control
                    tabIndex={this.state.tabEnable}
                    id={id}
                    type="text"
                    placeholder="Enter Price"
                    value={row.qty4 == null ? 0 : row.qty4}
                    onChange={(e) => this.updateState1(e, rowIndex, "qty4", id)}
                    onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "qty4")}
                    onBlur={(e: any) => this.amountBlur(e, rowIndex, "qty4")}
                    onKeyDown={(e) => this.handleTabKeyDown(e, rowIndex, "qty4")}
                    autoComplete="off"
                    pattern="[+-]?\d+(?:[.,]\d+)?"
                    maxLength={20}
                    // disabled={  row.itemName=="Quantity"  ? true:false}
                    title=""
                    className="form-control form-control-sm"
                    style={{ textAlign: 'right', fontWeight: isBold ? 'bold' : 'normal', backgroundColor: row.itemName == "Quantity" ? '#e9ecef' : '#ffbaba8a' }}
                  />
                </div>
              );
            },
          },
    
          ,
          {
            dataField: 'qty5',
    
            text: '',
            headerStyle: { width: '15%' },
            headerClasses: 'd-none',
            classes: 'text-end pe-4',
    
            formatter: (cell: any, row: any, rowIndex: any) => {
              let id = "txtqty5" + rowIndex + "txt";
              let disable = this.state.formData.CustomerID == 0 ? true : false;
              let isBold = row.itemName == "Quantity" ? true :false;
              return (
                <div>
                  <Form.Control
                    tabIndex={this.state.tabEnable}
                    id={id}
                    type="text"
                    placeholder="Enter Price"
                    value={row.qty5 == null ? 0 : row.qty5}
                    onChange={(e) => this.updateState1(e, rowIndex, "qty5", id)}
                    onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "qty5")}
                    onBlur={(e: any) => this.amountBlur(e, rowIndex, "qty5")}
                    onKeyDown={(e) => this.handleTabKeyDown(e, rowIndex, "qty5")}
                    autoComplete="off"
                    pattern="[+-]?\d+(?:[.,]\d+)?"
                    maxLength={20}
                    // disabled={  row.itemName=="Quantity"  ? true:false}
                    title=""
                    className="form-control form-control-sm"
                    style={{ textAlign: 'right', fontWeight: isBold ? 'bold' : 'normal', backgroundColor: row.itemName == "Quantity" ? '#e9ecef' : '#ffbaba8a' }}
                  />
                </div>
              );
            },
          },
        ];


        
    return (
      //  <div className="transaction-slideout invoice-entry pos-fxd index-1000">

      <section>
        <div className="details-drawer"
          style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
        // className="back-drop1  viewer-panel1 opacity "
        >
          <ToastContainer
            containerId={"userDetailSlideoutcontainer"}
            autoClose={3000}
          />

          <div className="d-flex">
            {!this.state.isOpenViewer && (
              <div
                className="back-drop1  viewer-panel1 opacity "
                // onClick={() => this.closeSlideOut()}
              ></div>
            )}

            <Container
              fluid

              className="body-sec viewer-panel back-drop p-0 "
              style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}

            >
              <div
                className="container-fluid py-1 bg-white d-flex align-items-center  border-bottom round-4"
              >
                <div className="divheader">
                  <h5 className="my-title">
                  {this.state.templateid == 0 && <span>New Part</span>}
              {this.state.templateid != 0 && (
                <span>
                  Part Name : {this.state.formData.firstline}
                </span>
              )}        
              </h5>


                  <div className="header-popout ml-auto">
                  <div className="container text-center">
  <div className="row align-items-start">
    <div className="col">
      </div>

      <div className="col">
      <button
                          type="button"
                          className="btn btn-primary cross"
                          onClick={this.closeSlideOut}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                              fill="#ffffff"
                            />
                          </svg>
                        </button>
      </div>
      </div>
      </div>
                  </div>
                </div>
              </div>
              <div
                className="scroll"
              >

                <section className="pb-3">
                  <div className="row g-3">

                  <div className="col-12 col-md-6" >
        <div className="card h-100">
          <div className="card-header">
            Part Details
          </div>
          <div className="card-body">
            <div className="row g-3">
            <div className="col-md-5" >
              <Form.Group controlId="customerName">
                       <div className="parent my-data">
                         <Form.Label className="font-semibold">Part Number</Form.Label>
                         <div
                           tabIndex={this.state.tabEnable}
                           className="type-head"
                         >
                           <Form.Control
                             type="text"
                             id="txtTemplate"
                             value={this.state.formData.partno}
                             onChange={(event: any) =>
                               this.handleChange(event, "partno")
                             }
                             autoComplete="off"
                             title=""
                           />
                         </div>
                       </div>
                     </Form.Group>

              </div>
              <div className="col-md-12" >
              <Form.Group controlId="customerName">
                    <div className="parent my-data">
                      <Form.Label className="font-semibold">Part Description</Form.Label>
                      <div
                        tabIndex={this.state.tabEnable}
                        className="type-head"
                      >
                        <Form.Control
                          as="textarea"
                          id="txtpartname"
                          value={this.state.formData.partname}
                          onChange={(event: any) =>
                            this.handleChange(event, "partname")
                          }
                          autoComplete="off"
                          rows={6}
                          title=""
                        />
                      </div>
                    </div>
                  </Form.Group>
              </div>
              <div className="row g-3">

              <div className="col-md-6" >
              <Form.Group controlId="customerName">
                       <div className="parent my-data">
                         <Form.Label className="font-semibold">Unit Price</Form.Label>
                         <div
                           tabIndex={this.state.tabEnable}
                           className="type-head"
                         >
                           <Form.Control
                             type="text"
                             id="txtTemplate"
                             value={this.state.formData.UnitPrice}
                             onChange={(event: any) =>
                               this.handleChange(event, "UnitPrice")
                             }
                             autoComplete="off"
                             title=""
                           />
                         </div>
                       </div>
                     </Form.Group>
              </div>
              <div className="col-md-6" >
              <Form.Group controlId="customerName">
                       <div className="parent my-data">
                         <Form.Label className="font-semibold">Delivery Time</Form.Label>
                         <div
                           tabIndex={this.state.tabEnable}
                           className="type-head"
                         >
                           <Form.Control
                             type="text"
                             id="txtTemplate"
                             value={this.state.formData.noofday}
                             onChange={(event: any) =>
                               this.handleChange(event, "DeliveryTime")
                             }
                             autoComplete="off"
                             title=""
                           />
                         </div>
                       </div>
                     </Form.Group>
              </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className="col-12 col-md-6" >
        <div className="card h-100">
          <div className="card-header">
            Customer Details
          </div>
          <div className="card-body">
            <div className="row g-3">
            <div className="row g-3">
            <div className="col-md-6" >
            <Form.Group controlId="customerName">
                        <div className="parent my-data">
                          <Form.Label className="font-semibold">
                            Customer Name
                          </Form.Label>
                          <div
                            tabIndex={this.state.tabEnable}
                            className="type-head"
                          >
                            <CustomerSearch
                              ref={this.customerSearch}
                              updateCustomerList={this.updateCustomerList}
                              handleCustomerChange={
                                this.handleCustomerChange
                              }
                            />
                          </div>
                        </div>
                      </Form.Group>

              </div>
              <div className="col-md-6" >
              <Form.Group controlId="customerName">
                        <div className="parent my-data">
                        <Form.Label className="font-semibold">Customer Code</Form.Label>
                         <div
                           tabIndex={this.state.tabEnable}
                           className="type-head"
                         >
                           <Form.Control
                             type="text"
                             id="txtTemplate"
                             value={this.state.formData.customercode}
                             onChange={(event: any) =>
                               this.handleChange(event, "CustomerCode")
                             }
                             autoComplete="off"
                             title=""
                           />
                          </div>
                        </div>
                      </Form.Group>
              </div>
             </div>
             
            </div>
          </div>
        </div>

      </div>

                    {/* <div className="col-12 col-md-3" >
                    <Form.Group controlId="customerName">
                    <div className="parent my-data">
                      <Form.Label className="font-semibold">Part Name</Form.Label>
                      <div
                        tabIndex={this.state.tabEnable}
                        className="type-head"
                      >
                        <Form.Control
                          type="text"
                          id="txtpartname"
                          value={this.state.formData.partname}
                          onChange={(event: any) =>
                            this.handleChange(event, "partname")
                          }
                          autoComplete="off"
                          title=""
                        />
                      </div>
                    </div>
                  </Form.Group>

                    </div> */}
                    {/* <div className="col-12 col-md-3" >
                    <Form.Group controlId="customerName">
                       <div className="parent my-data">
                         <Form.Label className="font-semibold">Part No</Form.Label>
                         <div
                           tabIndex={this.state.tabEnable}
                           className="type-head"
                         >
                           <Form.Control
                             type="text"
                             id="txtTemplate"
                             value={this.state.formData.partno}
                             onChange={(event: any) =>
                               this.handleChange(event, "partno")
                             }
                             autoComplete="off"
                             title=""
                           />
                         </div>
                       </div>
                     </Form.Group>
                    </div> */}
                    {/* <div className="col-12 col-md-3" >
                    <Form.Group controlId="customerName">
                       <div className="parent my-data">
                         <Form.Label className="font-semibold">Unit Price</Form.Label>
                         <div
                           tabIndex={this.state.tabEnable}
                           className="type-head"
                         >
                           <Form.Control
                             type="text"
                             id="txtTemplate"
                             value={this.state.formData.UnitPrice}
                             onChange={(event: any) =>
                               this.handleChange(event, "UnitPrice")
                             }
                             autoComplete="off"
                             title=""
                           />
                         </div>
                       </div>
                     </Form.Group>
                    </div> */}

                    {/* <div className="col-12 col-md-3" >
                    <Form.Group controlId="customerName">
                        <div className="parent my-data">
                          <Form.Label className="font-semibold">
                            Customer Name
                          </Form.Label>
                          <div
                            tabIndex={this.state.tabEnable}
                            className="type-head"
                          >
                            <CustomerSearch
                              ref={this.customerSearch}
                              updateCustomerList={this.updateCustomerList}
                              handleCustomerChange={
                                this.handleCustomerChange
                              }
                            />
                          </div>
                        </div>
                      </Form.Group>
                    </div> */}

                    
                    

                    
                  </div>
                  {/* <div className="row g-3">

<div className="col-12 col-md-3" >
<Form.Group controlId="customerName">
<div className="parent my-data">
  <Form.Label className="font-semibold">Description</Form.Label>
  <div
    tabIndex={this.state.tabEnable}
    className="type-head"
  >
    <Form.Control
      type="text"
      id="txtpartname"
      value={this.state.formData.pdescription}
      onChange={(event: any) =>
        this.handleChange(event, "pdescription")
      }
      autoComplete="off"
      title=""
    />
  </div>
</div>
</Form.Group>

</div>
<div className="col-12 col-md-3" >

</div>
<div className="col-12 col-md-3" >

</div>

<div className="col-12 col-md-3" >

</div>





</div> */}




  <div className="col-12 col-md-12 mt-3" >
        <div className="card h-100">
 <div className="card-header">
            Price Breakdown
          </div>
            <div className="card-body">
                <section style={{ overflowX: 'auto' }}>
                                        <div className="table-responsive mt-2" style={{ maxHeight: '400px' }}>
                                          <div className="ml-auto transactions-list">
                                            <BootstrapTable
                                              id="tblpricebreakup"
                                              keyField="rowId"
                                              data={this.state.qoSetup}
                                              columns={columns}
                                          
                                            />
                                          </div>
                                        </div>
                                      </section>
                                       <h6 style={{ color: 'green', cursor: 'pointer', marginTop: '2%', marginBottom: "2%" }} onClick={this.handleNewRowPrice}>+ Add Row</h6>
                                      
                                                              <div>
                                      
                                                                <section style={{ marginTop: '2%', marginRight: '0.4%' }}>
                                                                  <div className="table-responsive mt-2">
                                                                    <div className="ml-auto transactions-list">
                                                                      <BootstrapTable
                                                                        id="tblpricebreakupp"
                                                                        keyField="partId"
                                                                        data={[this.state.totals]}
                                                                        columns={columns1}
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </section>
                                      
                                      
                                                              </div>
            </div>
        </div></div>

                </section>




 <div className="filter-sec height-172">

                <br></br>
                <br></br>

              </div>

             

                <div className={"footer-section viewer-panel"}
                  style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
                >
  <div>
                    <div className="d-flex align-items-center justify-content-end height-72">
                      <div className="d-flex align-items-center">
                      {this.state.isStateChanged && hasEditPermission && (
                        <>
                          <Button variant="primary" type="button" className="space btn btn-primary btn-discard" onClick={() => this.handleDiscard(this.state.orderUniqueNo)}>
                            Discard
                          </Button>
                          <Button id="btnSave" variant="primary" type="button"
                            onClick={() => this.saveProduct()}
                          // disabled={this.state.formData.templatename === "" ? true : this.state.isDisabled}
                          //onKeyDown={(e: any) => this.onTAB('btnSave-1', 0, e)}

                          >{"Save"}</Button>

                        </>
                      )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </Container>
          </div>

          1

          {(this.state.isSpinner || this.state.isSaveSpinner) && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}






        </div>

      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId
});

export default connect(mapStateToProps)(ProductSlideout);